<div class="db-test-cdn" *ngIf="!pageLoading">
  <div class="db-test-cdn-header" [ngClass]="{'after': testCdnCreated}">
    <div class="db-test-cdn-header-before" *ngIf="!testCdnCreated">
      <h4><img src="assets/images/icons/cloudflare-big.svg" alt=""><span
              [innerHTML]="'text_cloudflare-enterprise' | dbText"></span></h4>
      <div class="db-cdn-desc mt15 mb25" [innerHTML]="'text_cdnDesc' | dbText"></div>
    </div>
    <div class="db-test-cdn-header-after mb25" *ngIf="testCdnCreated">
      <div class="db-site-screenshot" [ngStyle]="{backgroundImage: 'url(&quot;'+
                     (website?.screenshot && !website?.isLocalhost ?  'data:image/jpg;base64,' + website?.screenshot
                     : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}" ></div>
      <div class="db-test-cdn-header-after-texts">
        <h2>The demo page is ready! <i class="db-icon db-icon-info-lined" [dsTooltip]="'text_cdnDemoPageIsReadyTooltip' | dbText" dsTooltipAlign="left"></i></h2>
        <div class="db-test-cdn-header-after-texts-sub">Check how your homepage performs with CDN</div>
        <div class="db-after-links-wrap">
          <div class="db-after-link">
            <a href="{{optimizedCDNUrl}}" target='_blank' rel="noopener">{{optimizedCDNUrl}}</a>
            <i class="db-icon db-icon-ds-copy" [ngxClipboard] [cbContent]="optimizedCDNUrl" (click)="copied = true"
               [dsTooltip]="copied ? 'Copied' : 'Copy'" dsTooltipSize="small" dsTooltipColor="black"
               (onTooltipHide)="copied = false"></i>
          </div>
          <a class="db-after-link-green"  href="{{'https://pagespeed.web.dev/report?url=' + optimizedCDNUrl + '&form_factor=mobile'}}" target='_blank' rel="noopener">
             <span>Check improved score</span>
             <i class="db-icon db-icon-ds-arrow-oblique"></i>
          </a>
        </div>
      </div>
    </div>

  </div>

  <div class="db-cdn-pagespeed-data-wrap">
    <ng-container *ngFor="let item of pageSpeedData">
      <div class="db-cdn-pagespeed-data">
        <div class="db-cdn-pagespeed-data-title mb15" [innerHTML]="item?.title"></div>
        <div class="db-cdn-pagespeed-data-body">
          <div class="db-cdn-pagespeed-data-body-labels">
            <div class="db-cdn-pagespeed-data-body-label">Without CDN</div>
            <div class="db-cdn-pagespeed-data-body-label" *ngIf="!testCdnCreated">With CDN</div>
            <div class="db-cdn-pagespeed-data-body-label" *ngIf="testCdnCreated">Result with CDN</div>
          </div>
          <div class="db-cdn-pagespeed-data-body-values">
            <div class="db-cdn-pagespeed-data-body-value" [innerHTML]="item?.withoutCDN"></div>
            <div class="db-cdn-pagespeed-data-body-value green" [innerHTML]="item?.withCDN"></div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <p class="db-cdn-pagespeed-data-desc mt10 mb30" *ngIf="testCdnCreated">The copy will be automatically deleted in 1 day.</p>
  <div class="db-cdn-pagespeed-data-desc mt10" *ngIf="!testCdnCreated"><span>*</span> 2x better than Google’s recommended score</div>
  <div class="db-cdn-desc mt40 mb25" *ngIf="!testCdnCreated" [innerHTML]="'text_cdnDescSecondSection' | dbText"></div>
  <div class="db-cdn-impact-features mb30" *ngIf="!testCdnCreated">
    <div class="db-cdn-impact-feature" *ngFor="let feature of impactFeatures" [innerHTML]="feature"></div>
  </div>
  <div class="db-test-cdn-buttons mb40">
    <button class="ds-btn-black rectangle" *ngIf="!testCdnCreated" (click)="generateTestCdnPage()">
      <span *ngIf="!loading">{{'text_testCdn' | dbText | lowerCaseSpecificWords}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
    <a class="db-or-upgrade-now mt10" *ngIf="!testCdnCreated" [routerLink]="['/upgrade-plan']"><span>{{'text_orUpgradeNow' | dbText | lowerCaseSpecificWords}}</span></a>
    <a class="ds-btn-green rectangle"  *ngIf="testCdnCreated" [routerLink]="['/upgrade-plan']"><span>{{'text_upgrade' | dbText | lowerCaseSpecificWords}}</span></a>
    <a class="db-or-upgrade-now mt10" *ngIf="testCdnCreated" (click)="generateTestCdnPage(true)">
      <span *ngIf="!loading">Or Test Again</span>
      <db-loading-circular-spinner [color]="'gray'" *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>
  <div class="db-cdn-ttfb mb40">
    <div class="db-cdn-ttfb-title" [innerHTML]="'text_cdnTtfbTitle' | dbText"></div>
    <div class="db-cdn-ttfb-desc" [innerHTML]="'text_cdnTtfbDesc' | dbText"></div>
    <div class="db-cdn-ttfb-slider-wrap">
      <div class="db-cdn-ttfb-slider-tabs">
        <ng-container *ngFor="let slide of slider">
          <div class="db-cdn-ttfb-slider-tab-item" [ngClass]="{'active': slide.id === activeSlide}" (click)="activeSlide = slide.id" [innerHTML]="slide.tab"></div>
        </ng-container>
      </div>
      <div class="db-cdn-ttfb-slider-content-wrap">
        <div>
          <div class="db-cdn-ttfb-slider-content" *ngFor="let slide of slider" [ngClass]="{'show': slide.id === activeSlide}">
            <div class="db-cdn-ttfb-slider-content-texts" >
              <div class="db-cdn-ttfb-slider-content-texts-title" [innerHTML]="slide.title"></div>
              <div class="db-cdn-ttfb-slider-content-texts-desc" [innerHTML]="slide.desc"></div>
            </div>
          </div>
        </div>
        <video class="db-cdn-ttfb-slider-content-image" #testCDNVideo (canplay)="playVideo()" muted loop width="100%">
          <source src="assets/videos/testCDN.webm"
                  type="video/mp4">
        </video>
      </div>
    </div>
    <div class="db-test-cdn-buttons mt50">
      <button class="ds-btn-black rectangle" *ngIf="!testCdnCreated" (click)="generateTestCdnPage()">
        <span *ngIf="!loading">{{'text_testCdn' | dbText | lowerCaseSpecificWords}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
      <a class="ds-btn-green rectangle"  *ngIf="testCdnCreated" [routerLink]="['/upgrade-plan']"><span>{{'text_upgrade' | dbText | lowerCaseSpecificWords}}</span></a>
      <a class="db-or-upgrade-now mt10"  *ngIf="!testCdnCreated" [routerLink]="['/upgrade-plan']"><span>{{'text_orUpgradeNow' | dbText | lowerCaseSpecificWords}}</span></a>
    </div>
  </div>
  <!--<div class="db-cdn-trustpilot-section">
    <div class="db-cdn-trustpilot-section-review" *ngFor="let review of reviews">
      <img src="assets/images/logos/services/trustpilot.svg" alt="" class="trustpilot" />
      <div class="db-cdn-trustpilot-section-review-text" [innerHTML]="review.text"></div>
      <div class="db-cdn-trustpilot-section-review-author" [innerHTML]="review.author"></div>
    </div>
  </div>-->
  <div class="db-why-enable-cloudflare mt40 mb25"><span>Why Enable Cloudflare Enterprise CDN?</span><hr></div>
  <div class="db-why-enable-cloudflare-desc" [innerHTML]="'text_cdnContentFree' | dbText"></div>
  <div class="db-cdn-faq">
    <ng-container *ngFor="let faq of faqs">
      <ds-accordion class="mb10" [title]="faq.title" [img]="faq.img" [body]="faq.desc" [height]="54" [bgColor]="'grey'"></ds-accordion>
    </ng-container>
  </div>
  <div class="db-cdn-upgrade-block">
    <div [innerHTML]="'text_upgradeBlockCdn' | dbText"></div>
    <a class="ds-btn-green rectangle" [routerLink]="['/upgrade-plan']"><span>{{'text_upgrade' | dbText | lowerCaseSpecificWords}}</span></a>
  </div>
</div>
<db-loading-screen [ngClass]="{'hidden':!pageLoading}" [pageBlocker]="true"></db-loading-screen>
<iframe class="db-iframe" width="100%" height="100%" *ngIf="optimizedCDNUrl" [src]="optimizedCDNUrl | safe" frameborder="0" allow="autoplay" allowfullscreen></iframe>
